import { useState } from "react";
import Tree from "../Tree/Tree";
import { toast } from "sonner";

export default function Sidebar({
  zipRef,
  sidebarOpen,
  setSidebarOpen,
  showInput,
  zipUrl,
  setZipUrl,
  loadZipFromUrl,
  searchTerm,
  setSearchTerm,
  tree,
  onFileClick,
}) {
  const [loading, setLoading] = useState(false);

  if (!sidebarOpen) return null;

  const handleLoadZip = async () => {
    if (!zipUrl.trim()) {
      toast.warning("Please enter a ZIP URL");
      return;
    }

    const toastId = "zip-load";

    try {
      setLoading(true);
      toast.loading("Loading ZIP file…", { id: toastId });

      await loadZipFromUrl();

      toast.success("ZIP loaded successfully", { id: toastId });
    } catch (err) {
      console.log(err)
      toast.error("Failed to load ZIP. Check the link and try again.", {
        id: toastId,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    toast.message("Resetting workspace…");
    window.location.reload();
  };

  return (
    <aside className="sidebar">
      {zipRef != null && (
        <div className="sidebar-buttons">
          <button className="btn-ghost" onClick={() => setSidebarOpen(false)}>
            ❮ Hide Sidebar
          </button>

          <button className="btn-neutral" onClick={handleReset}>
            ⟳ Load new ZIP
          </button>

          <div className="search-files">
            <input
              placeholder="Search files"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>
      )}

      {showInput && (
        <>
          <label>Enter Zip URL</label>
          <input
            placeholder="Paste ZIP URL (Drive / Dropbox)"
            value={zipUrl}
            className="zip-url-input"
            onChange={(e) => setZipUrl(e.target.value)}
            disabled={loading}
          />

          <button
            className="btn-primary"
            onClick={handleLoadZip}
            disabled={loading}>
            {loading ? "Loading…" : "Load ZIP"}
          </button>
        </>
      )}

      <div className="sidebar-tree">
        <Tree nodes={tree} onFileClick={onFileClick} searchTerm={searchTerm} />
      </div>

      <div className="sidebar-ad hide-this">
        <div className="ad-placeholder">Advertisement</div>
      </div>
    </aside>
  );
}
